export default __webpack_public_path__ + "static/media/wohnungen_intro_web-lg@2x.0d8bdf00.jpg";